var _defs, _g, _circle, _circle2, _g2, _g3, _path, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyDeliver(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "empty state_img",
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.791,
    height: 105.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    x: 0.038,
    y: 6.483,
    width: 98.221,
    height: 99.317,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#c9cfd7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Messages Icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M37.232 67.847a1.8 1.8 0 01-1.8-1.8l-.442-36.425a7.1 7.1 0 017.089-7.092h29.6a7.1 7.1 0 017.089 7.092l.443 21.008a7.1 7.1 0 01-7.089 7.088H46.011l-7.355 9.434a1.8 1.8 0 01-1.423.7z",
    fill: "#e8e9ee"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.002 -.005)",
    filter: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M29.282 75.797a1.8 1.8 0 01-1.8-1.8l-.442-36.425a7.1 7.1 0 017.089-7.092h29.6a7.1 7.1 0 017.089 7.092l.443 21.008a7.1 7.1 0 01-7.089 7.088H38.061l-7.355 9.434a1.8 1.8 0 01-1.423.7z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 5",
    d: "M80.203 34.968v1.214h-4.856v-.951l2.772-3.278h-2.701v-1.214h4.694v.951l-2.772 3.278z",
    fill: "#b3c3cd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 7",
    d: "M77.774 24.122v2.054l-8.218.004v-1.609l4.689-5.55h-4.572v-2.056h7.945v1.609l-4.689 5.55z",
    fill: "#b3c3cd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 3",
    d: "M48.677 52.168a1.718 1.718 0 101.718 1.718 1.718 1.718 0 00-1.718-1.718",
    fill: "#c9cfd7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 1",
    d: "M54.056 45.887a4.9 4.9 0 01-4.431-3.193l-.129-.3-.125-.292.274-.161 1.1-.644.347-.21.164.378.129.3a2.974 2.974 0 002.671 1.962 2.974 2.974 0 002.666-1.959l.13-.3.161-.381.354.208 1.1.644.274.161-.125.292-.129.3a4.9 4.9 0 01-4.431 3.195zm-11.115 0a4.9 4.9 0 01-4.432-3.192l-.129-.308-.124-.288.274-.161 1.1-.644.35-.207.161.378.129.3a2.974 2.974 0 002.671 1.962 2.974 2.974 0 002.67-1.959l.129-.3.161-.381.355.208 1.1.643.274.161-.129.288-.13.3a4.9 4.9 0 01-4.43 3.2z",
    fill: "#c9cfd7"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 25",
    cx: 2.386,
    cy: 2.386,
    r: 2.386,
    transform: "translate(0 31.81)",
    fill: "#b3c3cd"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 28",
    cx: 2.386,
    cy: 2.386,
    r: 2.386,
    transform: "translate(81.91 62.824)",
    fill: "#b3c3cd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 26",
    transform: "translate(14.314 6.362)",
    fill: "none",
    stroke: "#bdc1c3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.386,
    cy: 2.386,
    r: 2.386,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.386,
    cy: 2.386,
    r: 1.886
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 27",
    transform: "translate(73.163)",
    fill: "none",
    stroke: "#bdc1c3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.386,
    cy: 2.386,
    r: 2.386,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.386,
    cy: 2.386,
    r: 1.886
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9648",
    d: "M14.314 60.996h-1.828v1.828h-.61v-1.828h-1.829v-.61h1.829v-1.829h.61v1.829h1.828z",
    fill: "#d2d7d9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "add-plus-button"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "add"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9648",
    d: "M46.919 11.691h-1.828v1.828h-.61v-1.828h-1.829v-.61h1.829V9.252h.61v1.829h1.828z",
    fill: "#d2d7d9"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "add-plus-button"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "add"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9648",
    d: "M101.791 38.729h-1.828v1.828h-.61v-1.828h-1.829v-.61h1.829V36.29h.61v1.829h1.828z",
    fill: "#d2d7d9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDeliver);
export default __webpack_public_path__ + "static/media/emptyDeliver.00fe0b02938a57bd39acac4f5491ae30.svg";
export { ForwardRef as ReactComponent };